import * as yup from "yup";

const emailSchema = yup.object().shape({
    email: yup.string().email().nullable(),
    bpayid : yup.number().required('We couldn’t validate your email or BPAY id. Please go back and try again.')
    
});
const schema = yup.object().shape({
    pan: yup.string().nullable().required('Card number is required').length(16,'Card number must have 16 digits'),
    expiryMonth: yup.string().notOneOf(["-1"],"Expiry month is required").required('The Month field is required.'),
    expiryYear: yup.string().notOneOf(["-1"], "Expiry year is required").required('The Year field is required.'),
    provider: yup.number().required().positive('Please select the Bank').integer(),
    isChecked: yup.bool().isTrue('Please agree to terms').required(),
});



export { schema, emailSchema };